import {
  SET_MARKET_AREAS_INFO,
  SET_MARKET_AREAS_LOADING,
  SET_SEARCHED_MARKET_AREA_NAME,
  SET_MARKET_AREA_SETTINGS,
  SET_MARKET_AREA_SETTINGS_LOADING,
  SET_MARKET_AREAS_AVAILABLE,
} from "./MarketAreasActions";
import { Actions, IMarketAreasState } from "./interfaces";

const initialState: IMarketAreasState = {
  isLoading: false,
  isSettingsLoading: false,
  marketAreasInfo: {
    totalCount: 0,
    activeCount: 0,
    objects: [],
  },
  searchedName: "",
  settings: null,
  isAvailable: null,
};

const MarketAreasReducer = (
  state: IMarketAreasState = initialState,
  action: Actions
) => {
  switch (action.type) {
    case SET_MARKET_AREAS_LOADING:
      return { ...state, isLoading: action.payload };
    case SET_MARKET_AREAS_INFO:
      return { ...state, marketAreasInfo: action.payload };
    case SET_SEARCHED_MARKET_AREA_NAME:
      return { ...state, searchedName: action.payload };
    case SET_MARKET_AREA_SETTINGS:
      return { ...state, settings: action.payload };
    case SET_MARKET_AREA_SETTINGS_LOADING:
      return { ...state, isSettingsLoading: action.payload };
    case SET_MARKET_AREAS_AVAILABLE:
      return { ...state, isAvailable: action.payload };
    default:
      return state;
  }
};

export default MarketAreasReducer;
